// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"351a4c3e","801":"99a9aa79"}[chunkId] + ".chunk.js";
};